import { render } from "./dashboard.vue?vue&type=template&id=e1aead0a"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1aead0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1aead0a', __exports__)) {
    console.log('reload')
    api.reload('e1aead0a', __exports__)
  }
  
  module.hot.accept("./dashboard.vue?vue&type=template&id=e1aead0a", () => {
    console.log('re-render')
    api.rerender('e1aead0a', render)
  })

}


export default __exports__